export default __webpack_public_path__ + "static/media/arrowLeftSlider.cc855606.svg";